import React from "react";

import "./TabContent.css";
import { useTranslation } from "react-i18next";

export const TabContent = ({ text }) => {
  const { t } = useTranslation();
  return (
    <div className="TabContent">
      <div className="TabContent__text">{t(text)}</div>
      <div className="TabContent__bottom-bar"></div>
    </div>
  );
};
